import { styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const Footer = styled('footer')(({ theme }) => ({
  position: 'relative',
  width: 'calc(100% - 80px)',
  maxWidth: '1732px',
  padding: '72px 0',
  borderTop: `1px solid ${theme.palette.color.divider}`,
  margin: '0 auto',

  [theme.breakpoints.down('2xl')]: {
    width: 'calc(100% - 60px)',
    maxWidth: '1328px',
    padding: '44px 0',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '40px 0',
  },
  [theme.breakpoints.down('md')]: {
    width: 'calc(100% - 40px)',
    padding: '36px 0',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'calc(100% - 32px)',
    padding: '32px 0',
  },
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '16px',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    textAlign: 'center',
    gap: '28px',
  },
}));

export const Copyright = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  color: theme.palette.color.fg.primary,

  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    width: '100%',
  },
}));

export const Nav = styled('nav')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '28px',

  '& p': {
    display: 'flex',
  },

  [theme.breakpoints.down('2xl')]: {
    gap: '24px',
  },
  [theme.breakpoints.down('xl')]: {
    gap: '20px',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '28px',
  },
}));

export const NavLink = styled(Link)(() => ({
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'opacity 0.3s ease-in-out',

  '&:hover': {
    opacity: 0.7,
  },
}));

export const ExternalNavLink = styled('a')(() => ({
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'opacity 0.3s ease-in-out',

  '&:hover': {
    opacity: 0.7,
  },
}));

export const Separator = styled('span')(({ theme }) => ({
  color: theme.palette.color.divider,
  userSelect: 'none',

  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Help = styled(Typography)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '4px',
  color: theme.palette.color.fg.primary,

  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
  },
}));

export const EmailLink = styled('a')(() => ({
  cursor: 'pointer',
  textDecoration: 'underline',
  textUnderlineOffset: '3px',
  transition: 'opacity 0.3s ease-in-out',

  '&:hover': {
    opacity: 0.7,
  },
}));
